// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"1386c9cf","688":"18d603ea","777":"cc6c8c4f"}[chunkId] + ".chunk.css";
};